/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions} from 'angular';
import TSCockpitResultDTO from '../../../models/TSCockpitResultDTO';

declare let require: any;
declare let angular: any;
require('./dv-text-value.scss');

export class DvTextValueComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        dataset: '<'
    };
    template = require('./dv-text-value.html');
    controller = DvTextValueController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvTextValueController {

    static $inject = [];

    dataset: TSCockpitResultDTO;

    constructor() {
    }

    $onInit() {
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-text-value/dv-text-value.ts